import { render, staticRenderFns } from "./comment-detail.vue?vue&type=template&id=4217d3d8&scoped=true&"
import script from "./comment-detail.vue?vue&type=script&lang=js&"
export * from "./comment-detail.vue?vue&type=script&lang=js&"
import style0 from "./comment-detail.vue?vue&type=style&index=0&id=4217d3d8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4217d3d8",
  null
  
)

export default component.exports